import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components/macro';

export interface ScCookieProps {
  bottom: number;
}

export const ScCookie = styled.div<ScCookieProps>`
  position: fixed;
  bottom: 32px;
  left: 182px;
  right: 0;
  z-index: 112;
  margin: 0 auto;
  background: ${({ theme }) => theme.secondaryColor3};
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3), 0px 10px 30px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  max-width: 640px;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  column-gap: 8px;

  .text {
    font-size: 14px;
    line-height: 1.43;
    font-weight: 400;

    a {
      color: ${({ theme }) => theme.mainColor};
      text-decoration: none;

      @media (hover: hover) {
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  @media (${device.mobile}) {
    text-align: center;
    flex-direction: column;
    row-gap: 16px;
    max-width: 100%;
    left: 0;
    right: 0;
    margin: 0 8px 8px;
    bottom: ${({ bottom }) => `${bottom}px`};
  }

  @media (${device.mobileS}) {
    .text {
      font-size: 12px;
    }
  }
`;

export const ScLink = styled.span`
  color: ${({ theme }) => theme.greenColor};
  text-decoration: underline;
  cursor: pointer;
  transition: 0.2s opacity;
  will-change: opacity;
  font-weight: 700;

  @media (hover: hover) {
    &:hover {
      opacity: 0.6;
    }
  }
`;
